"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.needsBillingCode = exports.isLegacyNote = exports.getInitialVideoChatCubbyScreenFromNote = void 0;
var _types = require("../types");
var _shared = require("../shared");
var _video = require("./video.utils");
var getInitialVideoChatCubbyScreenFromNote = function getInitialVideoChatCubbyScreenFromNote(note) {
  var _note$soap, _note$billingCode;
  return (note === null || note === void 0 ? void 0 : (_note$soap = note.soap) === null || _note$soap === void 0 ? void 0 : _note$soap.status) === _types.SessionNoteStatus.Draft ? _shared.VideoChatCubbyScreen.Notes : (note === null || note === void 0 ? void 0 : (_note$billingCode = note.billingCode) === null || _note$billingCode === void 0 ? void 0 : _note$billingCode.status) === _types.SessionNoteStatus.Draft ? _shared.VideoChatCubbyScreen.Billing : _shared.VideoChatCubbyScreen.Notes;
};
exports.getInitialVideoChatCubbyScreenFromNote = getInitialVideoChatCubbyScreenFromNote;
var isLegacyNote = function isLegacyNote(note) {
  return Object.hasOwn(note, 'isLegacyNote');
};
exports.isLegacyNote = isLegacyNote;
var needsBillingCode = function needsBillingCode(note) {
  if (isLegacyNote(note)) {
    return false;
  }

  // We don't know if the booking is billable until the patient
  // is no longer able to join the call
  // Return true until we know for sure billing codes aren't needed
  if ((0, _video.isBookingJoinable)(note)) {
    return true;
  }
  if (note.clinicianTimeOnCall && !note.patientTimeOnCall) {
    return false;
  }
  if (!note.cptCode) {
    return false;
  }
  return true;
};
exports.needsBillingCode = needsBillingCode;